import React from "react";
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from "@mui/material";
import { renderTruncatedText } from "../../../core/Constant";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    disableScrollLock: true,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      maxWidth: 350,
    },
    },
};

const DropDownComponent = ({
  isError = false,
  error = '',
  onchange,
  list,
  selectedValue = '',
  dropdownLabel = '',
  readOnly,
  isShowZero = true,
  isInactive = false,
  initialValue = "All",
  radius,
  backgroundColor,
  outerStyle = { padding: 10 },
  enableTooltip = true,
  fixedWidth = "200px"
}) => {

  const showMenuItem = (item, index) => {
    const menuItemStyle = {
      maxWidth: "100%",
      overflow: "hidden",
      display: "block",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };

    const getMenuLabel = (text) => {
      return enableTooltip ? renderTruncatedText(text, { limit: 30 }) : text;
    };
    let itemId = item?.id;
    let labelText = item?.name;

    if (item.course_name && item.course_id) {
      itemId = item.course_id;
      labelText = item.course_name;
    } else if (item.currency && item.currency_name) {
      itemId = item.id;
      labelText = item.currency;
    } else if (item.promoTypeId && item.promoType) {
      itemId = item.promoTypeId;
      labelText = item.promoType;
    }
      return (
        <MenuItem key={index} value={itemId} style={menuItemStyle}>
          {getMenuLabel(labelText)}
        </MenuItem>
      );
  };
  return (
    <Box sx={{ width: fixedWidth, borderRadius: '10px' }} style={outerStyle}>
      {dropdownLabel !== '' && (
        <p style={{ borderRadius: '10px', padding: 0, margin: 0, marginBottom: 10, color: "#4E657C", fontSize: 19, fontWeight: 700 }}>{dropdownLabel}</p>
      )}

      <Box sx={{ width: "100%" }}>
        <Select
          id="dropDown"
          disabled={isInactive}
          fullWidth={true}
          readOnly={readOnly}
          size="small"
          displayEmpty
          value={selectedValue}
          onChange={onchange}
          input={<OutlinedInput />}
          MenuProps={MenuProps}
          style={{ padding: '4px 4px', borderRadius: radius, backgroundColor: backgroundColor }}
          sx={{
            width: "100%",
              "& .MuiSelect-select": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                paddingRight: "32px !important", 
              }
            }}
      >
        {isShowZero ? (
              <MenuItem key={0}
          value={0}>
          {enableTooltip ? renderTruncatedText(initialValue, {limit : 45}) : initialValue}
        </MenuItem>
            ) : null}

          {list?.map((value, index) => (
            showMenuItem(value, index)
          ))}
        </Select>
      </Box>

      {isError ? <p className="input-error-text">{error}</p> : null}
    </Box>
  );
}

export default DropDownComponent;